import { Container, Stack, Typography } from "@mui/material";
import useClientContext from "../../../../context/useClientContext";
import ApplicationStatusTag from "../../../common/ApplicationStatusTag";
import InvestorPortalLinks from "./InvestorPortalLinks";

const GeneralInvestorPortalSettings = () => {
  const { investorPortalApp } = useClientContext();

  return (
    <Container maxWidth="md" disableGutters>
      <Stack spacing={3} sx={{ py: 2.5 }}>
        <Typography variant="subtitle1">Portal Links</Typography>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Typography color="secondary" sx={{ width: "3.5rem" }}>
            Status
          </Typography>
          <ApplicationStatusTag appStatus={investorPortalApp?.status ?? "NotConnected"} />
        </Stack>
        <InvestorPortalLinks />
      </Stack>
    </Container>
  );
};

export default GeneralInvestorPortalSettings;
